import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
const firebaseConfig = {
    apiKey: "AIzaSyDNtBZas_NJ5SEwfdneJL-DZ2QxZgGUfbo",
    authDomain: "instagramwebappclone9.firebaseapp.com",
    projectId: "instagramwebappclone9",
    storageBucket: "instagramwebappclone9.appspot.com",
    messagingSenderId: "386946632317",
    appId: "1:386946632317:web:b33468b592e7d169f2ff14",
    measurementId: "G-6H06TKFBEE"
};


const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth();
const storage = getStorage();

export { db, auth, storage };
